import "abortcontroller-polyfill";

import { gbConstants } from "../_constants";
import { authHeader } from "../_helpers";

export const heatmapService = {
    getHeatmap
};
const heatmapURL = `${gbConstants.HOST_SERVICE}/v1.1/heatmap`;

const AbortController = window.AbortController;
var controller = null;
var signal = null;

function getHeatmap(filter) {
    if (controller) {
        controller.abort();

        controller = null;
        signal = null;
    }

    controller = new AbortController();
    signal = controller.signal;
    signal.onabort = function() {
        // console.log("*********** onabort ***********");
        // console.log("2 signal = ", signal);
    };
    signal.addEventListener("abort", () => {
        // Logs true:
        // console.log("signal = ", signal);
        // console.log("signal aborted: ", signal.aborted);
    });

    //
    const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(filter),
        signal: signal
    };

    // console.log("start request");
    return fetch(heatmapURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            controller = null;
            signal = null;

            return response.json();
        })
        .then(heatmap => {
            if (heatmap.error && heatmap.error.code !== 200) {
                return Promise.reject(heatmap.error);
            }

            return heatmap;
        })
        .catch(err => {
            if (err.name === "AbortError") {
                // console.log("Fetch aborted");
            } else {
                return Promise.reject(err);
            }
            return err;
        });
}



// WEBPACK FOOTER //
// ./src/_services/heatmap.service.js